import { useState, useEffect, FormEvent } from 'react';
import axios from 'axios';
import config from '../Config';
import { useIonScreenAuth } from '../Authentication/Hooks/useIonScreenAuth';
import { UserDto } from '../DTO/UserDto';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingComponent from './LoadingComponent';

const Page_User = () => {
    let { id } = useParams();
    const context = useIonScreenAuth();
    const [user, setUser] = useState<UserDto | null>(null);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const abortController = new AbortController();
        getUserAsync(abortController);
        return () => {
            abortController.abort();
        };
    }, [id]);

    const getUserAsync = async (abortController: AbortController) => {
        try {
            let axiosRequestConfig = await context.getAxiosRequestObjectAsync(abortController);

            if (id != undefined) {
                let result = await axios.get<UserDto>(config.backEndAppApi + `/api/User/${id}`, axiosRequestConfig);
                setUser(result.data);
                return;
            }

            let newUser: UserDto = {
                id: -1,
                email: '',
                firstName: '',
                lastName: ''
            };
            setUser(newUser);
        }
        catch (error) {
            console.log(error);
        }
        finally {
            setLoading(false);
        }
    }

    const HandleSaveClicked = async () => {
        try {
            let axiosRequestConfig = await context.getAxiosRequestObjectAsync(null);

            if (id != undefined) {
                await axios.post(config.backEndAppApi + `/api/UpdateUser`, user, axiosRequestConfig);
                navigate('/users');
            }
            else {
                var result = await axios.post<UserDto>(config.backEndAppApi + `/api/AddUser`, user, axiosRequestConfig);
                navigate(`/user/${result.data.id}`);
            }
        }
        catch (error) {
            console.log(error);
            alert('Failed to save user');
        }
    }

    const HandleCancelClicked = () => {
        navigate('/users');
    }

    const onEmailChanged = (event: FormEvent<HTMLInputElement>) => {
        setUser({ ...user, email: event.currentTarget.value } as UserDto);
    }

    const onFirstNameChanged = (event: FormEvent<HTMLInputElement>) => {
        setUser({ ...user, firstName: event.currentTarget.value } as UserDto);
    }

    const onLastNameChanged = (event: FormEvent<HTMLInputElement>) => {
        setUser({ ...user, lastName: event.currentTarget.value } as UserDto);
    }

    if (loading) {
        return (<LoadingComponent />);
    }

    return (
        <>
            <h1 className='underline text-xl'>User - {`${user?.firstName} ${user?.lastName} (${user?.id})`}</h1>
            <br /><br />

            <div className='mb-4'>
                <label className='block text-gray-700 font-bold mb-2'>Email</label>
                <input 
                    className='w-full rounded border border-gray-300 px-3 py-2' 
                    type="email"
                    value={user?.email} 
                    onChange={onEmailChanged}
                />
            </div>

            <div className='mb-4'>
                <label className='block text-gray-700 font-bold mb-2'>First Name</label>
                <input 
                    className='w-full rounded border border-gray-300 px-3 py-2' 
                    value={user?.firstName} 
                    onChange={onFirstNameChanged}
                />
            </div>

            <div className='mb-4'>
                <label className='block text-gray-700 font-bold mb-2'>Last Name</label>
                <input 
                    className='w-full rounded border border-gray-300 px-3 py-2' 
                    value={user?.lastName} 
                    onChange={onLastNameChanged}
                />
            </div>

            <br /><br />
            <div className='flex gap-2'>
                <button 
                    className="bg-blue-300 text-white font-bold py-2 px-4 rounded hover:bg-blue-400" 
                    onClick={HandleSaveClicked}
                >
                    {id != undefined ? 'Save' : 'Add'}
                </button>
                <button 
                    className="bg-gray-300 text-white font-bold py-2 px-4 rounded hover:bg-gray-400" 
                    onClick={HandleCancelClicked}
                >
                    Cancel
                </button>
            </div>
        </>
    );
}

export default Page_User;
